/**
 * dreFormat — formatação de valores do módulo DRE.
 *
 * SÓ formatação (number/currency/percent/decimal). A cor/direção da variação é
 * calculada no BACKEND (campo `direction` de cada célula / `deltaDirection` dos
 * cards) — o front não decide semântica de cor, só consome. Ver api/dre.py.
 */

const nfNum = new Intl.NumberFormat('pt-BR')
const nfDec = new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 1, maximumFractionDigits: 1 })
const nfBRL = new Intl.NumberFormat('pt-BR', {
  style: 'currency', currency: 'BRL', minimumFractionDigits: 2, maximumFractionDigits: 2,
})

/** Formata um número conforme o tipo de métrica. */
export function formatValue(value, format) {
  if (value == null || Number.isNaN(value)) return '—'
  switch (format) {
    case 'currency': return nfBRL.format(value)
    case 'percent': return `${nfDec.format(value)}%`
    case 'multiple': return `${nfDec.format(value)}x`
    case 'decimal': return nfDec.format(value)
    case 'number':
    default: return nfNum.format(Math.round(value))
  }
}

/** Formata a variação % com sinal explícito (+/−). */
export function formatVar(varPct) {
  if (varPct == null || Number.isNaN(varPct)) return '—'
  const sign = varPct > 0 ? '+' : ''
  return `${sign}${nfDec.format(varPct)}%`
}

/**
 * Direção → classe de cor. A direção ('pos' | 'neg' | 'neutral') já vem pronta
 * do backend; esta função só faz o mapa 1:1 e trata ausência. Nenhuma regra de
 * "maior é melhor" no front — cor é puramente pelo sinal, decidido no backend.
 */
export function toneClass(direction) {
  return direction === 'pos' || direction === 'neg' ? direction : 'neutral'
}
